import { addFilter } from "@/redux/features/filterSlice";
import { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useDispatch } from "react-redux";

const LeaderBoardDropdown = ({ onOptionChange }: any) => {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("All Schools Rankings");

  const handleClick = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
    onOptionChange(option);
    setIsOpen(false);
  };

  const getOptionBackgroundColor = (option: string) => {
    return option === selectedOption ? "#D1D5DB" : "transparent";
  };
  // useEffect(() => {
  //   return () => {
  //     dispatch(addFilter(emptyFilter));
  //   };
  // }, []);
  return (
    <div className="container">
      <div className="row">
        <div
          className="col-12 d-flex justify-content-center justify-content-lg-end"
          style={{ paddingTop: "1rem" }}
        >
          <div style={{ position: "relative" }}>
            <button
              className="primary-button"
              style={{
                zIndex: "1",
                padding: "12px 20px",
                gap: "10px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                fontSize: "0.875rem",
                minHeight: "40px",
                minWidth: "180px",
                borderRadius: "34px",
                border: "1px solid #7A87F8",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onClick={handleClick}
            >
              {selectedOption}
              <FaChevronDown style={{ marginLeft: "8px" }} />
            </button>

            {isOpen && (
              <ul
                style={{
                  position: "absolute",
                  left: "0",
                  top: "100%",
                  width: "100%",
                  borderRadius: "0.375rem",
                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "white",
                  zIndex: "50",
                  padding: "0",
                  listStyleType: "none",
                  margin: "0",
                  cursor: "pointer",
                }}
              >
                {[
                  "All Schools Rankings",
                  "Individual Winners Ranking",
                  "Sports Wise Ranking",
                ].map((option) => (
                  <li key={option}>
                    <a
                      onClick={() => handleOptionClick(option)}
                      style={{
                        display: "block",
                        padding: "0.5rem 1rem",
                        fontSize: "0.875rem",
                        width: "100%",
                        textAlign: "center",
                        color: "#374151",
                        textDecoration: "none",
                        backgroundColor: getOptionBackgroundColor(option),
                        borderBottom:
                          option !== "Sports Wise Ranking"
                            ? "1px solid #E5E7EB"
                            : "none",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#F3F4F6")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          getOptionBackgroundColor(option))
                      }
                    >
                      {option}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderBoardDropdown;
